import styled from "styled-components";

export const ActivityFormRequestEditContainerStyled = styled.div`
  padding: 20px 0px 0px 0px;
  .breadcrumb_layout {
    margin-bottom: 30px;
  }
  .header_back_home_layout {
    display: none;
  }
  .body_layout {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
    padding: 0px 20px 40px 20px;
    .page_block {
      margin-bottom: 2rem;
      .page_label {
        margin-bottom: 0.5rem;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S16};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_BOLD};
      }
      .question_list {
        padding-left: 12px;
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 0px;
    .breadcrumb_layout {
      display: none;
    }
    .header_back_home_layout {
      display: block;
    }
    .body_layout {
      padding: 32px 20px 40px 20px;
    }
  }
`;
